// extracted by mini-css-extract-plugin
module.exports = {"action":"DropdownAction_action_3x-Dm"};